import styled from "styled-components";

export const ServicesContainer = styled.div`
	height: 560px;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	background: #61714d;

	@media screen and (max-width: 1010px) {
		height: 710px;
	}

	@media screen and (max-width: 768px) {
		height: 1000px;
	}

	@media screen and (max-width: 480px) {
		height: 950px;
	}
`;

export const ServicesWrapper = styled.div`
	max-width: 1170px;
	margin: 0 auto;
	display: grid;
	grid-template-columns: 1fr 1fr 1fr;
	align-items: center;
	grid-gap: 16px;
	padding: 0 50px;

	@media screen and (max-width: 1000px) {
		grid-template-columns: 1fr 1fr;
	}
	@media screen and (max-width: 768px) {
		grid-template-columns: 1fr;
		padding: 0 20px;
	}
`;

export const ServicesCard = styled.div`
	background: #fff;
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	align-items: center;
	border-radius: 10px;
	max-height: 540px;
	padding: 30px;
	box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
	transition: all 0.2s ease-in-out;

	&:hover {
		transform: scale() (1.02);
		transition: all 0.2s ease-in-out;
		cursor: pointer;
	}
`;

export const ServiceIconLink = styled.a`
	text-decoration: none;
`;
export const ServicesIcon = styled.img`
	height: 260px;
	width: 260px;
	margin-bottom: 20px;
	object-fit: contain;

	@media screen and (max-width: 1000px) {
		height: 140px;
		width: 160px;
	}
	@media screen and (max-width: 768px) {
		height: 130px;
		width: 200px;
	}
`;

export const ServicesH1 = styled.h1`
	font-size: 2.5rem;
	color: #fff;
	margin-bottom: 64px;

	@media screen and (max-width: 480px) {
		font-size: 2rem;
	}
`;
export const ServicesH2 = styled.h2`
	font-size: 1rem;
	margin-bottom: 10px;
`;
export const ServiceP = styled.p`
	font-size: 1rem;
	text-align: center;
`;

export const ButtonContainer = styled.div`
	height: 40px;
	width: 150px;
	display: flex;
	justify-content: space-between;
	background-color: transparent;
`;

export const LiveButton = styled.button`
	background: #01bf71;
	padding: 5px 10px;
	border: none;
	border-radius: 10px;
	color: #010606;
	font-size: 20px;
	outline: none;
	cursor: pointer;
	display: flex;
	justify-content: center;
	align-items: center;
	transition: all 0.2s ease-in-out;

	&:hover {
		transition: all 0.2 ease-in-out;
		background: #5c5cff;
		color: #fff;
	}
`;

export const CodeButton = styled.button`
	background: #5c5cff;
	padding: 5px 10px;
	border: none;
	border-radius: 10px;
	color: #fff;
	font-size: 20px;
	outline: none;
	cursor: pointer;
	display: flex;
	justify-content: center;
	align-items: center;
	transition: all 0.2s ease-in-out;

	&:hover {
		transition: all 0.2 ease-in-out;
		background: #01bf71;
		color: #010606;
	}
`;
